module["exports"] = [
  "Bgld.",
  "Ktn.",
  "NÖ",
  "OÖ",
  "Sbg.",
  "Stmk.",
  "T",
  "Vbg.",
  "W"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/state_abbr.js
// module id = 516
// module chunks = 0